var _rect, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFullVersion(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 48,
    viewBox: "0 0 45 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.0556641,
    width: 45,
    height: 47.5,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_11591_5263",
    transform: "matrix(0.0111111 0 0 0.0105263 0 0.0263158)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_11591_5263",
    width: 90,
    height: 90,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFoAAABaCAYAAAA4qEECAAAACXBIWXMAAAsTAAALEwEAmpwYAAADLElEQVR4nO2cPWsUURSGD4ofKIg2ImijoKKCBrSw1z9gYWklWIjxgzTJ3LNMsNHCykp/gz9AkCDYqIFIDKQw654zSSR+N7JpBGFlNhh29+5mJmbnzp2Z94FTzZw79z459+zOMhMiAAAAAAAAAAAAAEAURruJ9Q6xThPLKrG2Mo1BZH3deG1G3lKgt2m0voucEtaPEOtc9otUD0R3hJH37bU7rGS3ktkT0f9kO6nstXbRqqxojmXrqAvR05UXzfIme9FGm5UXbbSZveg8tip71jo2mg9EK0QTKroAW5U9mw9ah0I0oaILsFXZs/mgdShEEyq6AFuVPZsPWodCNKGiHW1VIw8z24FGJtE6OGPZWUkufI82Q5SdpeTCi+Yhyc5acilE8xZlu5BcGtH8n7JdSS6VaN6kbJeSSyeaU8p2LbmUojlBdh6SSyuaB8jOS3KpRXOP7Dwll140t2VP5i65EqLZk4BohWjKuwpR0Zq/OLQOzV8qerSWWHRej+2yR2H0V3kfRGefwsWD6PHbSbkvVPONmtzKXnT8okz8wkx1q3mWwvmd5IT4FbBKypZZCpYPk1Pala2j7X5V5g9Io00y8rrdLpxVMgAAAAAAAGA4hNF+qjXOJ8a4nLByJ+Ts+nH+eKbv+Kzn1s+ZWDxtHb8xs6PrOuHSsdRz58bx7tzWNvKWILqS7g5LXlq5rF87zlnoOz7Lz467tHnreBgd6rmTe5Z67kZfdOXG//TFWyA6J9FGP5HRGStYnli5qOgtiGa5lzqX0Tog2jtQ0Z71aLN41MpF69iC6IERnYLoYVY0RLtqHRLQ+NIBK662tlu5RlY6Ws4363icY/R3x/hz1jnVvWHZzNc7edeVG0QjXcdrjUs9Yz+3xoDoNKL1Qc9uiMjoNQqii2TkOrF8TvwjWqLlQ/vNADvuJ1a00Ud9cwf9DlOYig4bB8noj5S/lUQ09mVvouiBIauJogdFvMZCi44JGheIdTlhsQvEepL6USHRI2TkaUdc3vQYYX0fsYwRy6u1Cpc/xPqdjE5RTW5SuLJnw9zu6/cPlsd95n43VW7vZwcAAAAAAAAAAAAAVZu/EYLvtpjMDzoAAAAASUVORK5CYII="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFullVersion);
export default __webpack_public_path__ + "static/media/FullVersion.1f16b1007d3a12bc0f94b0b36a593c51.svg";
export { ForwardRef as ReactComponent };